/**
 * catalogOperator — operator-grade role check for the admin catalogue surface.
 *
 * policy-2026-08-01-tenant-admin-never-creates-apps: app creation, deployment
 * rollout and catalogue mutation are exclusively developer and operator verbs.
 * The tenant-admin role is request-and-govern only (sandbox requests, assign
 * the uat-tester, personas in the app realm) and must never see or reach the
 * admin tile actions (Admin / Deploy / Edit description).
 *
 * This is the SPA half (defense in depth — hiding, not the gate). The gate is
 * server-side: the service-broker registry mutations require
 * REGISTRY_DEVELOPER_ROLES / REGISTRY_ADMIN_ROLES, neither of which includes
 * tenant-admin (see infraops registry-tenant-admin-forbidden.test.ts).
 *
 * Config, not code: override via VITE_CATALOG_OPERATOR_ROLES (comma-separated).
 * NOTE the deliberate asymmetry with the server's CATALOG_ADMIN_ROLES
 * (services.ts), which includes tenant-admin — that list governs private-tile
 * VISIBILITY; this list governs mutation AFFORDANCES. Seeing is not touching.
 */

const raw = (import.meta.env?.VITE_CATALOG_OPERATOR_ROLES as string | undefined) ?? '';

export const CATALOG_OPERATOR_ROLES: readonly string[] =
  raw.split(',').map((s) => s.trim()).filter(Boolean).length > 0
    ? raw.split(',').map((s) => s.trim()).filter(Boolean)
    : ['service-admin', 'broker-operator', 'vertical-product-owner'];

/** True when the token carries at least one operator-grade catalogue role. */
export function isCatalogOperator(roles: readonly string[]): boolean {
  return roles.some((r) => CATALOG_OPERATOR_ROLES.includes(r));
}
